exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-3a730032] {\n  text-decoration: none;\n}\n.list-box-status[data-v-3a730032] {\n  -webkit-box-align: normal;\n      -ms-flex-align: normal;\n          align-items: normal;\n}\n.list-box-header[data-v-3a730032] {\n  min-height: 66px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a730032","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/ClaimTypes/SettingsClaimTypesBlock.vue
// module id = skKG
// module chunks = 0